var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "post-index-container" }, [
    _c("div", { staticClass: "block-title-container" }, [
      _vm.title
        ? _c(
            "h2",
            {
              staticClass: "title",
              domProps: { innerHTML: _vm._s(_vm.title) }
            },
            [_vm._v("Articles")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "filter-container" }, [
        _c(
          "div",
          {
            ref: "productWrap",
            staticClass: "select-wrap",
            class: { visible: _vm.productCategories.length > 0 }
          },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedProductCategory,
                    expression: "selectedProductCategory"
                  }
                ],
                staticClass: "products",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedProductCategory = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      return _vm.filterChanged()
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { name: "product", value: "" } }, [
                  _vm._v("All Products")
                ]),
                _vm._v(" "),
                _vm._l(_vm.productCategories, function(product, index) {
                  return _c("option", {
                    key: index,
                    attrs: { name: "product" },
                    domProps: {
                      value: product.term_id,
                      innerHTML: _vm._s(product.name)
                    }
                  })
                })
              ],
              2
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "marketWrap",
            staticClass: "select-wrap",
            class: { visible: _vm.markets.length > 0 }
          },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedMarket,
                    expression: "selectedMarket"
                  }
                ],
                staticClass: "markets",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedMarket = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      return _vm.filterChanged()
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { name: "market", value: "" } }, [
                  _vm._v("All Markets")
                ]),
                _vm._v(" "),
                _vm._l(_vm.markets, function(market, index) {
                  return _c("option", {
                    key: index,
                    attrs: { name: market },
                    domProps: {
                      value: market.term_id,
                      innerHTML: _vm._s(market.name)
                    }
                  })
                })
              ],
              2
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "posts-container bg-white-with-lines" }, [
      _vm.posts.length > 0
        ? _c(
            "div",
            { staticClass: "item-collection-list posts" },
            _vm._l(_vm.topPosts, function(item, index) {
              return _c("div", { key: index, staticClass: "item" }, [
                _c("div", { staticClass: "image-container" }, [
                  _c("img", { attrs: { src: _vm.getItemImage(item) } })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content-container" }, [
                  _c("div", {
                    staticClass: "top-title",
                    domProps: { innerHTML: _vm._s(_vm.getItemDate(item)) }
                  }),
                  _vm._v(" "),
                  _c("h2", {
                    staticClass: "title",
                    domProps: { innerHTML: _vm._s(item.post_title) }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "description",
                    domProps: {
                      innerHTML: _vm._s(
                        item.acf_fields.feature_settings.post_excerpt
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "button-container" }, [
                    _c(
                      "a",
                      {
                        staticClass: "hover-button orange",
                        attrs: { href: item.permalink }
                      },
                      [_vm._v("Continue reading")]
                    )
                  ])
                ])
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "item-collection-grid" },
        _vm._l(_vm.bottomPosts, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              ref: "gridItem",
              refInFor: true,
              staticClass: "item post",
              on: {
                mouseleave: function($event) {
                  return _vm.removeHover(index)
                }
              }
            },
            [
              _c("div", {
                staticClass: "top-title",
                domProps: { innerHTML: _vm._s(_vm.getItemDate(item)) }
              }),
              _vm._v(" "),
              _c("h2", {
                staticClass: "title",
                domProps: { innerHTML: _vm._s(item.post_title) }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "description-short",
                domProps: {
                  innerHTML: _vm._s(
                    item.acf_fields.feature_settings.post_excerpt
                  )
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "toggle-container hover-remove" }, [
                _c("i", {
                  staticClass: "fas fa-plus tx-orange plus hover-toggle",
                  on: {
                    mouseenter: function($event) {
                      return _vm.addHover(index)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hover-details" }, [
                _c("div", {
                  staticClass: "description",
                  domProps: {
                    innerHTML: _vm._s(
                      item.acf_fields.feature_settings.post_excerpt
                    )
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "button-container" }, [
                  _c(
                    "a",
                    {
                      staticClass: "hover-button orange",
                      attrs: { href: item.permalink }
                    },
                    [_vm._v("Continue reading")]
                  )
                ])
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "emptyList",
          staticClass: "no-items",
          staticStyle: { display: "none" }
        },
        [
          _c("h3", { staticClass: "roboto-mono message" }, [
            _vm._v("No articles found that match this filter.")
          ])
        ]
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", { staticClass: "ajax-spinner" }, [
            _c("i", {
              staticClass: "fas fa-spinner fa-spin float-right tx-dark-gray"
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowLoadMore
        ? _c("div", { staticClass: "load-more-container" }, [
            _c(
              "a",
              {
                staticClass: "btn tx-dark-gray float-right",
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.loadPosts()
                  }
                }
              },
              [
                _vm._v("Load more "),
                _c("i", { staticClass: "fas fa-chevron-down" })
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }